// NPM packages
import React from 'react';
import { Typography } from '@mui/material';
import styled from '@emotion/styled';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';

// All other imports

const Root = styled.ul({
  margin: 0,
  padding: 0,
  listStyle: 'none',
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(20rem, 1fr))',
  columnGap: '3rem',
  rowGap: '2rem',
});

const Item = styled.li({
  display: 'flex',
});
const PrincipleIcon = styled(FontAwesomeIcon)(({ theme: { palette } }) => ({
  color: palette.primary.light,
  marginRight: '0.5rem',
}));
const TextWrapper = styled.div({});
const PrincipleTitle = styled(Typography)({
  marginBottom: '0.5rem',
});
const PrincipleDescription = styled(Typography)({
  maxWidth: '15rem',
});

export interface Principle {
  title: string;
  description: string;
  icon: FontAwesomeIconProps['icon'];
}

export interface PrinciplesProps {
  className?: string;
  principles: Principle[];
}

export default function Principles(
  props: PrinciplesProps
): React.ReactElement | null {
  const { className, principles } = props;
  return (
    <Root className={className} aria-label="core principles">
      {principles.map((principle) => (
        <Item key={principle.title}>
          <PrincipleIcon icon={principle.icon} size="5x" fixedWidth />
          <TextWrapper>
            <PrincipleTitle variant="h3">{principle.title}</PrincipleTitle>
            <PrincipleDescription>{principle.description}</PrincipleDescription>
          </TextWrapper>
        </Item>
      ))}
    </Root>
  );
}
